import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecomissionMeterDialog, MeterManagementComponent } from './meter-management.component';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { ContentCardModule } from 'src/app/shared/components/content-card/content-card.module';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CardDialogModule } from 'src/app/shared/components/card-dialog/card-dialog.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DecommissionMeterNodeComponent } from './decommission-meter-node/decommission-meter-node.component';
import { MigrateMeterComponent } from './migrate-meter/migrate-meter.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AddMeterNodeDialogModule } from 'src/app/shared/components/add-meter-node-dialog/add-meter-node-dialog.module';
import { UpdateMeterNodeDialogModule } from 'src/app/shared/components/update-meter-node-dialog/update-meter-node-dialog.module';
import { TariffDisplayPipe } from './tariff-display.pipe';
import { MatSortModule } from '@angular/material/sort';



@NgModule({
  declarations: [
    MeterManagementComponent,
    DecommissionMeterNodeComponent,
    MigrateMeterComponent,
    DecomissionMeterDialog,
    TariffDisplayPipe
  ],
  imports: [
    CommonModule,
    MatTableModule,
    FlexLayoutModule,
    FlexModule,
    ContentCardModule,
    MatSortModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatPaginatorModule,
    MatDividerModule,
    MatSelectModule,
    MatDatepickerModule,
    CardDialogModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    AddMeterNodeDialogModule,
    UpdateMeterNodeDialogModule,
    MatDialogModule
  ],
  exports: [
    MeterManagementComponent,
    DecommissionMeterNodeComponent,
    MigrateMeterComponent,
    DecomissionMeterDialog
  ]
})
export class MeterManagementModule { }
